import ReactGA from 'react-ga4';
import _ from 'lodash';

import { UaEventOptions } from './types';

export const logEvent = (args: UaEventOptions) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({ ...args, action: _.isString(args.action) ? args.action : 'unknown' });
  }
};
